import { render, staticRenderFns } from "./BlInfo.vue?vue&type=template&id=58f5395e&scoped=true"
import script from "./BlInfo.vue?vue&type=script&lang=js"
export * from "./BlInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f5395e",
  null
  
)

export default component.exports